import React from "react";
import { Col } from "react-bootstrap";
import BirthdayUser from "./BirthdayUser";
import "./BirthdayMonth.css";

function BirthdayMonth({ title, title_english, users, count, language }) {
  return (
    <Col className="birthday-month">
      <Col className="birthday-month-header">
        <h3>{language === "es" ? title : title_english}</h3>
      </Col>
      <Col className="birthday-month-content">
        {users.map((user) => (
          <BirthdayUser
            key={user._id}
            firstName={user.firstName}
            lastName={user.lastName}
            profileName={user.profileName}
            profileNameEnglish={user.profileNameEnglish}
            language={language}
            day={user.day}
          />
        ))}
      </Col>
    </Col>
  );
}

export default BirthdayMonth;
